var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.content != '')?_c('section',{domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }